import React, { useState } from 'react';
import { showError } from 'utils';
import DeleteAction from './DeleteAction';

const DeleteActionForTable = props => {
  const { onClick } = props;
  const [loading, setLoading] = useState<boolean>(false);
  
  const handleClick = async () => {
    setLoading(true);
    try {
      await onClick();
    } catch (e) {
      showError(e);
    }finally{
      setLoading(false);
    }
  };
  
  return (
    <>
      <DeleteAction loading={loading} onClick={handleClick} />
    </>
  );
};

export default DeleteActionForTable;
